import { MessageInstance } from 'antd/lib/message';
import { createContext, useContext } from 'react';

export const MessageContext = createContext<MessageInstance | undefined>(undefined);

export function MessageProvider({
  children,
  messageApi,
}: {
  children: React.ReactNode;
  messageApi: MessageInstance;
}) {
  return <MessageContext.Provider value={messageApi}>{children}</MessageContext.Provider>;
}

export function useMessage() {
  const messageApi = useContext(MessageContext);
  if (!messageApi) {
    throw new Error('MessageApi not found');
  }
  return messageApi;
}
